import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-crud-action-buttons',
    templateUrl: './crud-action-buttons.component.html',
    styleUrls: ['./crud-action-buttons.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CrudActionButtonsComponent implements OnInit {

    @Input() public isDisabled: boolean = true;
    @Input() public returlUrl: string;

    @Input() public isRequesting: boolean = false;

    @Output() isSaveButtonClicked = new EventEmitter();
    @Output() isCancelButtonClicked = new EventEmitter();

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
    ) { }

    ngOnInit(): void {
    }

    public saveButtonClicked(): void {
        this.isSaveButtonClicked.emit();
    }

    public returlUrlClicked(): void {

        if (this.returlUrl) {
            this._router.navigate([this.returlUrl]);
        } else {
            this.isCancelButtonClicked.emit();
        }

    }

    public cancelButtonClicked(): void {
        this.isCancelButtonClicked.emit();
    }

}
